(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-video-poster]').forEach(function (poster) {
    poster.addEventListener('click', function () {
      var container = poster.closest('.video-section__media');
      var video = container.querySelector('video');
      if (video) {
        video.play();
        poster.hidden = true;
      }
    });
  });

  document.querySelectorAll('[data-external-play]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var container = btn.closest('.video-section__media');
      var iframe = container.querySelector('iframe');
      if (!iframe) return;

      var type = iframe.getAttribute('data-video-type');
      if (type === 'vimeo') {
        iframe.contentWindow.postMessage(JSON.stringify({ method: 'play' }), '*');
      } else if (type === 'youtube') {
        iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'playVideo', args: '' }), '*');
      }

      btn.hidden = true;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
